/**
 * Environment Variables Hook
 *
 * Type-safe access to Expo public environment variables.
 * All variables must be prefixed with EXPO_PUBLIC_ to be accessible
 * in client-side code.
 */

import Constants from 'expo-constants';

export interface EnvConfig {
  EXPO_PUBLIC_POSTHOG_KEY: string;
  EXPO_PUBLIC_POSTHOG_HOST: string;
  EXPO_PUBLIC_TURNSTILE_SITE_KEY: string;
  /** E2E testing mode - bypasses Turnstile and other interactive widgets */
  EXPO_PUBLIC_E2E_MODE?: string;
}

export function useEnv(): EnvConfig {
  const expoConfig = Constants.expoConfig;
  const env = expoConfig?.extra?.eas || {};

  return {
    EXPO_PUBLIC_POSTHOG_KEY: process.env.EXPO_PUBLIC_POSTHOG_KEY || env.EXPO_PUBLIC_POSTHOG_KEY || '',
    EXPO_PUBLIC_POSTHOG_HOST: process.env.EXPO_PUBLIC_POSTHOG_HOST || env.EXPO_PUBLIC_POSTHOG_HOST || '',
    EXPO_PUBLIC_TURNSTILE_SITE_KEY: process.env.EXPO_PUBLIC_TURNSTILE_SITE_KEY || env.EXPO_PUBLIC_TURNSTILE_SITE_KEY || '',
    EXPO_PUBLIC_E2E_MODE: process.env.EXPO_PUBLIC_E2E_MODE || env.EXPO_PUBLIC_E2E_MODE,
  };
}
